'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useSessionMonitor } from '@/utilities/useSessionMonitor'
import { IMPERSONATION_TOKEN_TYPE } from '@/utilities/stytch/useImpersonationAuth'
import { SHARED_PATHS } from '@/utilities/paths'

export const SessionMonitor = ({ redirectTo = '/login' }: { redirectTo?: string }) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  // Disable monitoring only on `/authenticate` during impersonation, since it's mounted root-wide.
  const isImpersonating =
    pathname === SHARED_PATHS.authenticate &&
    searchParams.get('stytch_token_type') === IMPERSONATION_TOKEN_TYPE
  useSessionMonitor({ redirectTo, enabled: !isImpersonating })
  return null
}
